import { useEffect, useRef, useCallback } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Services from "@/components/Services";
import HowItWorks from "@/components/HowItWorks";
import Impact from "@/components/Impact";
import WaysToHelp from "@/components/WaysToHelp";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = useCallback((selector) => {
    const el = document.querySelector(selector);
    if (el && lenisRef.current) {
      lenisRef.current.scrollTo(el, { offset: -72, duration: 1.4 });
    }
  }, []);

  return (
    <div className="App bg-cream text-ink antialiased">
      <Navbar scrollTo={scrollTo} />
      <main>
        <Hero scrollTo={scrollTo} />
        <Marquee />
        <About />
        <Services />
        <HowItWorks />
        <Impact />
        <WaysToHelp />
        <Contact />
      </main>
      <Footer scrollTo={scrollTo} />
      <Toaster position="top-center" richColors />
    </div>
  );
}
